import { useSession } from '@tgtg/core/session';
import { Navigate, Outlet, useLocation } from 'react-router';

const RequireAuth = () => {
  const { session } = useSession();
  const location = useLocation();

  if (!session.isAuthenticated) {
    // Redirect to login, preserving the attempted URL for post-login redirect
    return <Navigate to='/login' state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
